/**
 * Map a calendar/list booking API row to a react-big-calendar style event.
 */
export const mapBookingToCalendarEvent = (resData) => {
  const startTimeParts = resData.booking_start_time.split(":");
  const endTimeParts = resData.booking_end_time.split(":");

  let bookingDate = new Date();

  if (resData.booking_date) {
    const bd = resData.booking_date.split("-");

    if (bd.length === 3) {
      bookingDate = new Date(
        parseInt(bd[2], 10),
        parseInt(bd[1], 10) - 1,
        parseInt(bd[0], 10)
      );
    }
  }

  const staffName = [resData.staff_first_name, resData.staff_last_name]
    .filter(Boolean)
    .join(" ");

  const inviteeName = [resData.invitee_first_name, resData.invitee_last_name]
    .filter(Boolean)
    .join(" ");

  return {
    id: resData.id,
    title: resData.event_name,
    inviteeName,
    start: new Date(
      bookingDate.getFullYear(),
      bookingDate.getMonth(),
      bookingDate.getDate(),
      parseInt(startTimeParts[0], 10),
      parseInt(startTimeParts[1], 10),
      0
    ),
    end: new Date(
      bookingDate.getFullYear(),
      bookingDate.getMonth(),
      bookingDate.getDate(),
      parseInt(endTimeParts[0], 10),
      parseInt(endTimeParts[1], 10),
      0
    ),
    type: resData.type,
    staffProfileImage: resData.staff_profile_image || "",
    staffName,
    avatarEmail: resData.staff_email || "",
  };
};
